import ThemeModal from "components/Common/ThemeModal"
import { Badge, Col, Row, Spinner } from "reactstrap"
import { formatReadableDate } from "utils/formatDate"
import { formatCurrency } from "utils/formatCurrency"
import { getEntityLabel, getUserLabel } from "pages/AccountPages/utils/displayValue"

const DetailItem = ({ label, value, valueClassName = "" }) => {
  return (
    <div className="py-2 border-bottom h-100" style={{ borderColor: "rgba(15, 23, 42, 0.08)" }}>
      <div className="text-uppercase text-muted fw-semibold" style={{ fontSize: 10, letterSpacing: 0.9 }}>{label}</div>
      <div className={`fw-semibold text-dark ${valueClassName}`.trim()} style={{ fontSize: 14 }}>{value || "-"}</div>
    </div>
  )
}

const AccountCustomerRefundView = ({ modal, toggleModal, refund, loading }) => {
  const customerName = getEntityLabel(refund?.customer, refund?.customer_id, "Customer")
  const accountName = getEntityLabel(refund?.account, refund?.account_id, "Account")
  const paymentMethodName = getEntityLabel(refund?.payment_method || refund?.paymentMethod, refund?.payment_method_id, "Method")
  const refundedBy = getUserLabel(refund?.refundedBy || refund?.refunded_by)

  return (
    <ThemeModal isOpen={modal} toggle={toggleModal} title="Customer Refund Details" size="lg">
      {loading ? (
        <div className="text-center py-4">
          <Spinner size="sm" />
        </div>
      ) : !refund ? (
        <div className="text-center py-4 text-muted">No details available.</div>
      ) : (
        <div>
          {refund.is_reversed && (
            <div className="alert alert-warning py-2 px-3 mb-3" style={{ fontSize: 13 }}>
              This refund has been <strong>reversed</strong> by a ledger reversal entry.
            </div>
          )}
          <Row className="g-3 mb-2">
            <Col md={4}><DetailItem label="Customer" value={customerName} /></Col>
            <Col md={4}><DetailItem label="Vehicle" value={getEntityLabel(refund.vehicle, refund.vehicle_id, "Vehicle")} /></Col>
            <Col md={4}>
              <DetailItem
                label="Amount"
                value={
                  <Badge color="danger" className="fs-6">
                    {formatCurrency(refund.amount || 0, refund.account?.currency || "BDT")}
                  </Badge>
                }
              />
            </Col>
            <Col md={4}><DetailItem label="Payment Method" value={paymentMethodName} /></Col>
            <Col md={4}><DetailItem label="Refund From Account" value={accountName} /></Col>
            <Col md={4}><DetailItem label="Refund Date" value={refund.refund_date ? formatReadableDate(refund.refund_date) : "-"} /></Col>
            <Col md={4}><DetailItem label="Refunded By" value={refundedBy} /></Col>
            <Col md={4}><DetailItem label="Reason" value={refund.reason} /></Col>
            <Col md={4}><DetailItem label="Status" value={refund.is_reversed ? "Reversed" : "Active"} /></Col>
            <Col md={12}><DetailItem label="Notes" value={refund.notes} /></Col>
          </Row>

          {Array.isArray(refund.images) && refund.images.length > 0 && (
            <div className="mt-3">
              <div className="text-uppercase text-muted fw-semibold mb-2" style={{ fontSize: 10, letterSpacing: 0.9 }}>Attached Images</div>
              <div className="d-flex flex-wrap gap-2">
                {refund.images.map(img => (
                  <a key={img.id} href={img.url} target="_blank" rel="noreferrer">
                    <img src={img.url} alt={img.original_name || "voucher"} className="rounded border" style={{ width: 90, height: 70, objectFit: "cover" }} />
                  </a>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </ThemeModal>
  )
}

export default AccountCustomerRefundView
